import React, { useState } from "react";
import PhotoZoom from "../PhotoZoom/PhotoZoom";
import styles from "./PhotoGallery.module.scss";

interface IPhoto {
  dosya: string;
  dosyaTip: string;
  sira: number;
  id: string;
}

interface PhotoGalleryProps {
  photos: IPhoto[];
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ photos }) => {
  const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);
  const photoSort = photos.sort((a, b) => a.sira - b.sira);
  console.log("photoSort: ", photoSort);

  const getPhotoGroups = (photos: IPhoto[]) => {
    const groups = [];
    let currentIndex = 0;

    while (currentIndex < photos.length) {
      const pattern = Math.floor(currentIndex / 7); // 7 fotoğrafta bir pattern tekrarı (1 + 3 + 3)
      const positionInPattern = currentIndex % 7; // Pattern içindeki pozisyon

      if (positionInPattern === 0) {
        // İlk fotoğraf - tekli geniş
        groups.push({
          type: "single",
          photos: photos.slice(currentIndex, currentIndex + 1),
        });
        currentIndex += 1;
      } else if (positionInPattern === 1) {
        // İkinci grup - sol 1, sağ 2 (altlı üstlü)
        const groupSize = Math.min(3, photos.length - currentIndex);
        groups.push({
          type: "split",
          photos: photos.slice(currentIndex, currentIndex + groupSize),
        });
        currentIndex += groupSize;
      } else if (positionInPattern === 4) {
        // Son grup - 3'lü yan yana
        const groupSize = Math.min(3, photos.length - currentIndex);
        groups.push({
          type: "triple",
          photos: photos.slice(currentIndex, currentIndex + groupSize),
        });
        currentIndex += groupSize;
      }
    }

    return groups;
  };

  const handlePhotoClick = (src: string) => {
    setSelectedPhoto(src);
  };

  return (
    <>
      <div className={styles.gallery}>
        {getPhotoGroups(photoSort).map((group, groupIndex) => (
          <div
            key={groupIndex}
            className={`${styles.row} ${styles[group.type]}`}
          >
            {group.type === "split" ? (
              <>
                <div className={styles.leftSide}>
                  <div
                    className={styles.photoContainer}
                    onClick={() => handlePhotoClick(group.photos[0].dosya)}
                  >
                    <img
                      src={group.photos[0].dosya}
                      alt={`${group.photos[0].sira}`}
                      className={styles.photo}
                    />
                  </div>
                </div>
                <div className={styles.rightSide}>
                  {group.photos.slice(1).map((photo) => (
                    <div
                      key={photo.id}
                      className={styles.photoContainer}
                      onClick={() => handlePhotoClick(photo.dosya)}
                    >
                      <img
                        src={photo.dosya}
                        alt={`${photo.sira}`}
                        className={styles.photo}
                      />
                    </div>
                  ))}
                </div>
              </>
            ) : (
              group.photos.map((photo) => (
                <div
                  key={photo.id}
                  className={styles.photoContainer}
                  onClick={() => handlePhotoClick(photo.dosya)}
                >
                  <img
                    src={photo.dosya}
                    alt={`${photo.sira}`}
                    className={styles.photo}
                  />
                </div>
              ))
            )}
          </div>
        ))}
      </div>
      {selectedPhoto && (
        <PhotoZoom src={selectedPhoto} onClose={() => setSelectedPhoto(null)} />
      )}
    </>
  );
};

export default PhotoGallery;
